@if (CompanyId && (VendorId || ClientRegisteredVendorId || ExemptVendorId)) {
  <form [formGroup]="DocumentAndNotesForm" class="container-fluid">
    <div class="row justify-content-between align-items-center mb-1">
      <div class="col">
        <h3>Vendor Files</h3>
      </div>
      <div class="col-4">
        <button class="btn btn-primary" (click)="uploadFile()">Add File</button>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col d-flex flex-column align-items-end">
        <div class="form-check">
          <label for="showArchivedFiles" class="form-check-label m-0"
            >Show archived?</label
          >
          <input
            id="showArchivedFiles"
            type="checkbox"
            class="form-check-input"
            formControlName="showArchivedFiles"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="grid-container">
          <app-company-vendor-files-grid
            [gridName]="'ClientVendorDocuments'"
            [suppliedQueryData]="CompanyVendorFilesGridQuery"
            [ColumnIdToColumnActions]="ColumnIdToColumnActionsCompanyVendorGrid"
            (actionEvent)="companyVendorFileGridAction($event)"
            [getCalculatedColumnActions]="calculatedColumnActions"
            [TooltipMap]="TooltipMap"
            [(reloadGridData)]="reloadCompanyVendorFilesGrid"
          ></app-company-vendor-files-grid>
        </div>
      </div>
    </div>
    <div class="row justify-content-between align-items-center mb-1">
      <div class="col">
        <h3>Signed Documents</h3>
      </div>
      @if (isAdminUser()) {
        <div class="col-4">
          <button class="btn btn-primary" (click)="uploadSignedDocument()">
            Upload Signed Document
          </button>
        </div>
      }
    </div>
    <form
      [formGroup]="SignedDocumentActionsForm"
      class="row justify-content-end"
    >
      <div class="col d-flex flex-column align-items-end">
        <div class="form-check">
          <label for="showArchived" class="form-check-label m-0"
            >Show archived?</label
          >
          <input
            id="showArchived"
            type="checkbox"
            class="form-check-input"
            formControlName="showArchived"
          />
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col">
        <div class="grid-container">
          <app-signed-documents-grid
            [gridName]="'ViveAdminSignedDocuments'"
            [suppliedQueryData]="SignedDocumentsSuppliedGridQueryData"
            [ColumnIdToColumnActions]="SignedDocumentColumnIdToColumnActions"
            [getCalculatedColumnActions]="calculatedSignedDocumentActions"
            (actionEvent)="signedDocumentsAction($event)"
            [(reloadGridData)]="reloadSignedDocumentsGrid"
          ></app-signed-documents-grid>
        </div>
      </div>
    </div>
    <div class="row justify-content-between align-items-center my-1">
      <div class="col">
        <h3>Vendor History</h3>
      </div>
      <div class="col-4">
        <button class="btn btn-primary" (click)="createNote()">Add Note</button>
      </div>
    </div>
    <div class="row justify-content-end mb-2">
      <div class="col d-flex flex-column align-items-end">
        <div class="row">
          <div class="col d-flex flex-column align-items-start">
            <div class="form-check">
              <label for="hideSystemLogs" class="form-check-label m-0"
                >Hide system logs?</label
              >
              <input
                id="hideSystemLogs"
                type="checkbox"
                class="form-check-input"
                formControlName="showSystemLogs"
              />
            </div>
            <div class="form-check">
              <label for="showAccountingLogs" class="form-check-label m-0"
                >Show accounting logs?</label
              >
              <input
                id="showAccountingLogs"
                type="checkbox"
                class="form-check-input"
                formControlName="showAccountingLogs"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="grid-container">
        <app-notes-grid
          [gridName]="'ClientVendorHistory'"
          [suppliedQueryData]="NotesGridQuery"
          [ColumnIdToColumnActions]="ColumnIdToColumnActionsNotesGrid"
          (rowClick)="notesGridAction({ action: 'view', rowData: $event.data })"
          [(reloadGridData)]="reloadNotesGridQuery"
        ></app-notes-grid>
      </div>
    </div>
    <div class="row">
      <div class="col grid-container">
        <app-change-log
          [SuppliedQueryObject]="ChangeLogSuppliedData"
        ></app-change-log>
      </div>
    </div>
  </form>
}
